<template>
  <div id="travel">
    <div id="content">
      <Header
        :page="'travel'"
        :title_one="'transfers'"
        :action_one="''"
        :banner_docsok_msg="doc_ok"
      ></Header>
      <div
        class="description"
        v-html="
          $t(
            'transfer.general_info_' +
              user.event_name.toLowerCase().replace(/ /gi, '') +
              (player.pickup
                ? '_type_' + player.pickup
                : player.join_campus
                ? '_type_' + player.join_campus
                : '')
          )
        "
      ></div>

      <div class="left">
        <div class="title">{{ $t("transfer.arrival_title") }}</div>
        <template v-if="arrive == '' && event.transfers">
          <div class="row actions nobackground">
            <button class="mainButton" @click="addTravel(1)">
              {{ $t("add") }}
            </button>
          </div>
        </template>
        <template v-else-if="arrive != ''">
          <!-- <div class="row info">
            {{ $t("transfer.info_arrive") }}
          </div> -->
          <div class="row">
            <div class="item mid">
              <div class="label">{{ $t("params.transport_mode") }}</div>
              <div class="value">
                {{ transport_modes[arrive.transport_mode][0] }}
              </div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.transport_number") }}</div>
              <div class="value">{{ arrive.transport_number }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.transport_company") }}</div>
              <div class="value">{{ arrive.transport_company }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.origin_city") }}</div>
              <div class="value">{{ arrive.origin.city }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.destination") }}</div>
              <div class="value">
                {{
                  arrive.destination.entity_type != 0
                    ? getLocationName(
                        arrive.destination.entity_type,
                        arrive.destination.entity_id
                      )
                    : arrive.destination.name
                }}
              </div>
            </div>
            <div class="item mid"></div>

            <div class="item mid">
              <div class="label">{{ $t("params.date") }}</div>
              <div class="value">{{ arrive.destination.date }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.hour") }}</div>
              <div class="value">{{ arrive.destination.hour }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.contact_name") }}</div>
              <div class="value">{{ arrive.contact_name }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.contact_phone") }}</div>
              <div class="value">{{ arrive.contact_phone }}</div>
            </div>

            <div class="item">
              <div class="label">{{ $t("params.observations") }}</div>
              <div class="value">{{ arrive.observations }}</div>
            </div>
            <div class="item center">
              <button
                class="mainButton center"
                @click="editTravel(arrive.id)"
                v-if="event.transfers"
              >
                {{ $t("edit") }}
              </button>
            </div>
          </div>
        </template>
        <div
          class="info"
          v-html="
            $t(
              'transfer.arrival_info_' +
                user.event_name.toLowerCase().replace(/ /gi, '')
            )
          "
        ></div>
      </div>

      <div class="right">
        <div class="title">{{ $t("transfer.departure_title") }}</div>
        <template v-if="departure == '' && event.transfers">
          <div class="row actions nobackground">
            <button class="mainButton" @click="addTravel(3)">
              {{ $t("add") }}
            </button>
          </div>
        </template>
        <template v-else-if="departure != ''">
          <!-- <div class="row info">
            {{ $t("transfer.info_departure") }}
          </div> -->
          <div class="row">
            <div class="item mid">
              <div class="label">{{ $t("params.transport_mode") }}</div>
              <div class="value">
                {{ transport_modes[departure.transport_mode][0] }}
              </div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.transport_number") }}</div>
              <div class="value">{{ departure.transport_number }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.transport_company") }}</div>
              <div class="value">{{ departure.transport_company }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.origin") }}</div>
              <div class="value">
                {{
                  departure.origin.entity_type != 0
                    ? getLocationName(
                        departure.origin.entity_type,
                        departure.origin.entity_id
                      )
                    : departure.origin.name
                }}
              </div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.destination") }}</div>
              <div class="value">{{ departure.destination.city }}</div>
            </div>

            <div class="item mid"></div>

            <div class="item mid">
              <div class="label">{{ $t("params.date") }}</div>
              <div class="value">{{ departure.origin.date }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.hour") }}</div>
              <div class="value">{{ departure.origin.hour }}</div>
            </div>

            <div class="item mid">
              <div class="label">{{ $t("params.contact_name") }}</div>
              <div class="value">{{ departure.contact_name }}</div>
            </div>
            <div class="item mid">
              <div class="label">{{ $t("params.contact_phone") }}</div>
              <div class="value">{{ departure.contact_phone }}</div>
            </div>

            <div class="item">
              <div class="label">{{ $t("params.observations") }}</div>
              <div class="value">{{ departure.observations }}</div>
            </div>

            <div class="item center">
              <button
                v-if="event.transfers"
                class="mainButton center"
                @click="editTravel(departure.id)"
              >
                {{ $t("edit") }}
              </button>
            </div>
          </div>
        </template>
        <div
          class="info"
          v-html="
            $t(
              'transfer.departure_info_' +
                user.event_name.toLowerCase().replace(/ /gi, '')
            )
          "
        ></div>
      </div>

      <div class="section" v-if="Object.values(travelInternal).length > 0">
        <span class="title">{{ $t("titles.my_transfers") }}</span>

        <v-data-table
          class="dataTable"
          id="players"
          :headers="tableHeaders"
          :items="Object.values(travelInternal)"
          :no-data-text="''"
          :no-results-text="'Hola'"
          :hideActions="true"
        >
          <template v-slot:items="props">
            <td>{{ transport_modes[props.item.transport_mode][0] }}</td>
            <td>{{ props.item.transport_number }}</td>
            <td>{{ props.item.transport_company }}</td>
            <td v-if="props.item.type == '1'">
              {{ props.item.destination.date }}
            </td>
            <td v-else>{{ props.item.origin.date }}</td>
            <td v-if="props.item.type == '1'">
              {{ props.item.destination.hour }}
            </td>
            <td v-else>{{ props.item.origin.hour }}</td>
            <td
              v-if="
                props.item.origin.entity_type != '0' &&
                props.item.origin.entity_id == null
              "
            >
              {{ $t("undefined") }}
            </td>
            <td v-else-if="props.item.origin.entity_type != '0'">
              {{
                getLocationTransfer(
                  props.item.origin.entity_type,
                  props.item.origin.entity_id
                ).name
              }}
            </td>
            <td v-else>{{ props.item.origin.city }}</td>
            <td
              v-if="
                props.item.destination.entity_type != '0' &&
                props.item.destination.entity_id == null
              "
            >
              {{ $t("undefined") }}
            </td>
            <td v-else-if="props.item.destination.entity_type != '0'">
              {{
                getLocationTransfer(
                  props.item.destination.entity_type,
                  props.item.destination.entity_id
                ).name
              }}
            </td>
            <td v-else>{{ props.item.destination.city }}</td>
            <td>{{ props.item.pax }}</td>
            <td v-if="props.item.cost != null">{{ props.item.cost }}€</td>
            <td v-else>-</td>
            <td>{{ props.item.observations }}</td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Header from "@/components/layout/Header";
import Equipment from "@/components/ui/Equipment.vue";

export default {
  name: "travel",
  components: {
    Header,
    Equipment
  },
  data() {
    return {
      type: "",
      title_two: "",
      // user: {},
      countries: {},
      positions: {},
      alergies: {},
      staff_level: {},
      diets: {},
      contact_type: {},
      error: {
        responsable: false,
      },

      travel: {
        1: {
          transport_mode: 1,
          transport_number: "5874",
          transport_company: "ALSA",
          origin: {
            entity_id: 2,
            name: "Aeroport T1",
            date: "25/12/2019",
            hour: "10:58",
          },
          destination: {
            entity_id: 1,
            name: "Maremagnum",
          },
          n_pax: 50,
          cost: 500,
          observations: "Ninguna",
        },
        2: {
          transport_mode: 1,
          transport_number: "5874",
          transport_company: "ALSA",
          origin: {
            entity_id: 2,
            name: "Aeroport T1",
            date: "25/12/2019",
            hour: "10:58",
          },
          destination: {
            entity_id: 1,
            name: "Maremagnum",
          },
          n_pax: 50,
          cost: 500,
          observations: "Ninguna",
        },
      },
      tableHeaders: [
        {
          text: i18n.t("params.transport_mode"),
          value: "transport_mode",
          sortable: true,
        },
        {
          text: i18n.t("params.transport_number"),
          value: "transport_number",
          sortable: false,
        },
        {
          text: i18n.t("params.transport_company"),
          value: "transport_company",
          sortable: true,
        },
        { text: i18n.t("params.date"), value: "origin.date", sortable: true },
        { text: i18n.t("params.hour"), value: "origin.hour", sortable: true },
        {
          text: i18n.t("params.origin_place"),
          value: "origin.entity_id",
          sortable: true,
        },
        {
          text: i18n.t("params.destination"),
          value: "destination.entity_id",
          sortable: true,
        },
        { text: i18n.t("params.n_pax"), value: "pax", sortable: true },
        { text: i18n.t("params.cost"), value: "cost", sortable: true },
        {
          text: i18n.t("params.observations"),
          value: "observations",
          sortable: false,
        },
      ],

      arrive: "",
      departure: "",
      doc_ok: false
    };
  },
  computed: {
    travels() {
      var list = this.$store.getters["travel/getList"];
      var findArrive = Object.values(list).find((obj) => {
        return obj.type == 1;
      });
      findArrive ? (this.arrive = findArrive) : (this.arrive = "");

      var findDesparture = Object.values(list).find((obj) => {
        return obj.type == 3;
      });
      findDesparture
        ? (this.departure = findDesparture)
        : (this.departure = "");

      return list;
    },

    player() {
      return this.$store.getters["person/getPerson"];
    },

    travelInternal() {
      var result = {};
      if (Object.values(this.travels).length > 0) {
        for (var key in this.travels) {
          var item = this.travels[key];
          if (item.type != "1" && item.type != "3") {
            result[key] = item;
          }
        }
      }
      return result;
    },

    locations() {
      return this.$store.getters["travel/getLocations"]();
    },

    hotels() {
      return this.$store.getters["travel/getHotels"]();
    },

    facilities() {
      return this.$store.getters["travel/getFacilities"]();
    },

    transport_modes() {
      var oOptions = this.$store.getters.getTransportMode();
      var aResult = [];
      for (var k in oOptions) {
        aResult[oOptions[k].id] = [];
        aResult[oOptions[k].id].push(
          i18n.t("transfer.transport_mode." + oOptions[k].name)
        );
      }
      return aResult;
    },

    user() {
      return this.$store.getters["user/getUser"];
    },

    event() {
      return this.$store.getters["getCurrentEvent"]();
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.$overlay.show();
      var self = this;

      // scroll to top
      window.scroll(0, 0);
      var self = this;

      this.$store
        .dispatch("person/loadPersonCampus", {
          campus_id: this.user.event_id,
          participant_id: this.user.participant_id,
        })
        .then(function () {
          self.$store.dispatch("travel/loadTravelInfo").then(function () {
            self.$store
              .dispatch("travel/loadParticipantTravels", {
                id_rel: self.user.participant_id,
              })
              .then(function () {
                self.$overlay.hide();
              });
          });
        });
    },

    addTravel(type) {
      this.$router.push({ name: "campus_travel_add", params: { type: type } });
    },

    editTravel(id) {
      this.$router.push({ name: "campus_travel_edit", params: { id: id } });
    },

    getLocationTransfer(entity_type, entity_id) {
      // console.log("getLocationTransfer",entity_type,entity_id)
      if (parseInt(entity_type) == 4) {
        console.log(
          "HOTEL",
          this.$store.getters["travel/getHotels"]()[entity_id]
        );
        return this.$store.getters["travel/getHotels"]()[entity_id];
      } else if (parseInt(entity_type) == 5) {
        console.log(
          "FACILITY",
          this.$store.getters["travel/getFacilities"]()[entity_id]
        );
        return this.$store.getters["travel/getFacilities"]()[entity_id];
      } else if (parseInt(entity_type) == 11) {
        var locations = this.$store.getters["travel/getLocations"]();
        console.log("LOCATION", locations[entity_id]);
        return locations[entity_id] ? locations[entity_id] : "";
      }
    },

    getLocationName(entity_type, entity_id) {
      if (parseInt(entity_type) == 4) {
        return this.hotels[entity_id].name;
      } else if (parseInt(entity_type) == 5) {
        return this.facilities[entity_id].name;
      } else if (parseInt(entity_type) == 11) {
        return this.locations[entity_id] ? this.locations[entity_id].name : "";
      }
    },
  },
  watch: {
    $route: "load",
  },
};
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}

#content {
  padding: 0 12px !important;
  padding-bottom: 50px !important;

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    &.info {
      text-align: left !important;
    }

    &.nobackground {
      background-color: unset;
    }

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;

      &.mid {
        width: 50%;
      }
      &.center {
        text-align: center;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: #191919;
    display: block;
    width: 100%;
    margin: 6px;
    font-family: AvantGarde-Bold !important;
    text-transform: uppercase;
    padding: 2px 0;

    &.sub {
      margin-left: 12px;
    }
  }

  .travel {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .travel-role,
    .travel-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .travel-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    width: 50%;
    display: inline-block;
    padding: 12px;
  }
  .left {
  }
  .right {
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mainButton {
  width: 150px !important;
  padding: 0;
  margin: 0;
  height: 100%;
  min-width: 40px;
  outline: none;
  cursor: pointer;
  font-size: 8pt;
  font-family: Speedee-Bold;
  border-radius: 3px;
  border: 1px solid #fc8926;
  text-transform: uppercase;
  background-color: transparent;
  color: #c55c00;
  height: 40px;
  padding: 0;
  font-family: Roboto-Bold;
  font-size: 14px;
  line-height: 14px;
  transition: background-color 0.5s ease;
  float: left;

  &.center {
    float: none;
  }

  &:hover {
    background-color: #fc8a2623 !important;
  }
}

.section {
  float: left;
  display: block;
  width: 100%;
}

.search {
  float: right;
}

.dataTable {
  > div {
    table {
      text-align: center;
      width: 100%;
      margin: 20px auto 0;
      border-radius: 5px;

      overflow: visible;
      min-width: 600px;

      th {
        background-color: $secondary-color;
        background-color: #ddd;
      }
      td,
      th {
        border: 1px solid $secondary-color;
        padding: 12px !important;
        text-align: left;
        border-left: 0;
        border-right: 0;
        min-width: 60px;
      }

      tr:nth-child(even) {
        background-color: #f7f7f7;
      }

      th {
        font-weight: normal;
        border: 0 solid $secondary-color;
        color: $main-color;
        color: #333;
        padding: 20px;
        text-transform: uppercase;
      }
      th.column[role="columnheader"] {
        padding: 20px 12px 12px 12px !important;
      }

      th:nth-child(1) {
        width: 20%;
      }

      th:nth-child(2) {
        width: 20%;
      }

      th:nth-child(3) {
        width: 20%;
      }

      th:nth-child(4) {
        width: 20%;
      }

      th:nth-child(5) {
        width: 10%;
      }

      th:nth-child(6) {
        width: 10%;
      }

      tr:last-child {
        // border-bottom: 4px solid $main-color;
      }
    }
  }
}
</style>
